import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MitarbeiterItem } from './mitarbeiter.model';
import {CollectionApiResponse} from '../../../lib/util/api-response';
import {FilterItem} from '../Mitarbeiterverwaltung/filter.model';
import {SaldoItem} from '@src/app/pages/Mitarbeiterverwaltung/saldo.model';
import {UserInfoItem} from '@src/app/pages/Mitarbeiterverwaltung/userInfo.model';

type Mitarbeiter = CollectionApiResponse<MitarbeiterItem>;
type Saldos = CollectionApiResponse<SaldoItem>;
type UserInfos = CollectionApiResponse<UserInfoItem>;

@Injectable()
export class MitarbeiterService {
    /**
     * Constructor of address service
     *
     * @param http - The http client
     */
    constructor(private http: HttpClient) {}

    /**
     * Returns a list of addresses
     *
     * @returns - An observable that emits the response
     */
    public getAllMitarbeiter(item: string): Observable<Mitarbeiter> {
      const firmaId = item;
      // tslint:disable-next-line:max-line-length
      return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/getAllMitarbeiter.php?${sessionStorage.getItem('session')}`) as Observable<
          Mitarbeiter
        >;
    }

  public getAllMitarbeiterSelectbox(item: string): Observable<Mitarbeiter> {
    const firmaId = item;
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/getAll/getAllMitarbeiterSelectbox.php?${sessionStorage.getItem('session')}`) as Observable<
      Mitarbeiter
      >;
  }

  public getFilteredMitarbeiter(filterOption: string, item: FilterItem): Observable<Mitarbeiter> {
    const filter = filterOption;
    const filterItem = item;
    const firmaId = sessionStorage.getItem('firmaId');
    // tslint:disable-next-line:max-line-length
    return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/getFilteredMitarbeiter.php?${sessionStorage.getItem('session')}&filter=${filter}`, filterItem) as Observable<
      Mitarbeiter
      >;
  }

  public getSaldo(userId: number): Observable<SaldoItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/getSaldo.php?${sessionStorage.getItem('session')}&userId=${userId}`) as Observable<
      SaldoItem
      >;
  }

  public getUserInfo(userId: number, showYears: number): Observable<UserInfos> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/getUserInfo.php?${sessionStorage.getItem('session')}&userId=${userId}&showYears=${showYears}`) as Observable<
      UserInfos
      >;
  }

  public addUserInfo(userInfo: UserInfoItem): Observable<UserInfoItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.post(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/addUserInfo.php?${sessionStorage.getItem('session')}`, userInfo) as Observable<
      UserInfoItem
      >;
  }

  public editUserInfo(userInfo: UserInfoItem): Observable<UserInfoItem> {
    // tslint:disable-next-line:max-line-length
    return this.http.put(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/editUserInfo.php?${sessionStorage.getItem('session')}`, userInfo) as Observable<
      UserInfoItem
      >;
  }

  public deleteUserInfo(saldoId: number, userId: number): Observable<number> {
    // tslint:disable-next-line:max-line-length
    return this.http.delete(window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/deleteUserInfo.php?${sessionStorage.getItem('session')}&userInfoId=${saldoId}&userId=${userId}`) as Observable<
      number
      >;
  }


  public add(item: MitarbeiterItem): Observable<MitarbeiterItem> {
    return this.http.post(window.location.protocol + '//' + window.location.hostname +
      `/myDay/backend/mitarbeiterverwaltung/addMitarbeiter.php?${sessionStorage.getItem('session')}`, item) as Observable<
      MitarbeiterItem
      >;
  }

  public edit(mitarbeiter: MitarbeiterItem): Observable<MitarbeiterItem> {
    return this.http.put(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/editMitarbeiter.php?${sessionStorage.getItem('session')}`,
      mitarbeiter,
    ) as Observable<MitarbeiterItem>;
  }

  public delete(mitarbeiter: MitarbeiterItem): Observable<MitarbeiterItem> {
    return this.http.put(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/deleteMitarbeiter.php?${sessionStorage.getItem('session')}`,
      mitarbeiter
    ) as Observable<MitarbeiterItem>;
  }

  public reactivate(mitarbeiter: MitarbeiterItem): Observable<MitarbeiterItem> {
    return this.http.put(
      window.location.protocol + '//' + window.location.hostname + `/myDay/backend/mitarbeiterverwaltung/reactivateMitarbeiter.php?${sessionStorage.getItem('session')}`,
      mitarbeiter
    ) as Observable<MitarbeiterItem>;
  }

}
